export default function Writer ()
{
    return (
        <h1>wellcome writer</h1>
    );
}